'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _action = require('../action');

var _table = require('./table');

var _dialog = require('./dialog');

var _dialog2 = _interopRequireDefault(_dialog);

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

var _Menu = require('antd/es/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _Icon = require('antd/es/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Row = require('antd/es/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Col = require('antd/es/Col');

var _Col2 = _interopRequireDefault(_Col);

var _qrcode = require('./qrcode');

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var filters = ['All', 'Doc', 'JS', 'CSS', 'Img', 'Other'];

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home(props) {
    _classCallCheck(this, Home);

    var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));

    _this.state = {
      showRequestDetail: false,
      requestDetail: null,
      check: 'All',
      keys: '',
      hideConnectUrls: true,
      showQRCode: false
    };
    return _this;
  }

  _createClass(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.ios = _socket2.default;
      var socket = _socket2.default.connect('http://' + location.hostname + ':9998');
      socket.on('pageReady', function (data) {
        _this2.setState(data);
      });

      socket.on('data', function (data) {
        var length = data.toString().length;
        var maxLen = 1 * 1024 * 1024;
        var obj = JSON.parse(data);
        var socketData = obj.socketData || '';
        var path = obj.path;
        var isSocketIOURL = /^\/(socket\.io|network)/.test(path);

        if (isSocketIOURL) {
          console.warn('socket.io本身的请求，忽略');
          return;
        }

        //obj.originLength = socketData.length;

        if (obj.originLength > maxLen) {
          obj.socketData = '内容太长，无法查看！';
        }

        _this2.props.onArrive(obj);
      });

      socket.on('connectreq', function (data) {
        if (data.hostname === location.hostname && data.port === '9998') {
          // 忽略插件本身的请求
        } else {
          _this2.props.onArrive(data);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var reqRows = document.querySelectorAll('.request-row');
      var len = reqRows.length;
      var isClick = this.isClick;

      // 如果不是隐藏click导致的渲染，滚动到最后

      if (len && !isClick) {
        reqRows[len - 1].scrollIntoView();
      }

      if (isClick) {
        this.isClick = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _ref = this.state || {},
          proxyPath = _ref.proxyPath,
          sslPath = _ref.sslPath,
          httpPort = _ref.httpPort,
          check = _ref.check,
          showQRCode = _ref.showQRCode;

      var _url = 'http://' + location.hostname + ':' + httpPort;

      return _react2.default.createElement(
        'div',
        { className: 'app-body' },
        _react2.default.createElement(
          _Menu2.default,
          { mode: 'horizontal', selectedKeys: ['1'], theme: 'dark' },
          _react2.default.createElement(
            _Menu2.default.Item,
            { key: 'mail' },
            'hiproxy-plugin-network'
          ),
          _react2.default.createElement(
            _Menu2.default.Item,
            null,
            _react2.default.createElement(
              'a',
              { onClick: function onClick() {
                  _this3.props.clearAll();_this3.onClose();
                } },
              _react2.default.createElement(_Icon2.default, { type: 'delete' }),
              'Clear'
            )
          ),
          _react2.default.createElement(
            _Menu2.default.Item,
            null,
            _react2.default.createElement(
              'a',
              { href: _url + proxyPath },
              _react2.default.createElement(_Icon2.default, { type: 'file-text' }),
              'PAC File'
            )
          ),
          _react2.default.createElement(
            _Menu2.default.Item,
            null,
            _react2.default.createElement(
              'a',
              { href: _url + sslPath,
                onMouseLeave: this.hideQRCode.bind(this),
                onMouseMove: this.showQRCode.bind(this),
                onMouseEnter: this.showQRCode.bind(this) },
              _react2.default.createElement(_Icon2.default, { type: 'cloud-download' }),
              'SSL Certificate'
            )
          ),
          _react2.default.createElement(
            _Menu2.default.Item,
            null,
            _react2.default.createElement(
              'a',
              { href: 'https://github.com/hiproxy/hiproxy-plugin-network', target: '_blank' },
              _react2.default.createElement(_Icon2.default, { type: 'github' }),
              'GitHub'
            )
          )
        ),
        _react2.default.createElement(_qrcode2.default, { onMouseLeave: this.hideQRCode.bind(this), onMouseEnter: this.showQRCode.bind(this), visible: showQRCode, url: _url + sslPath }),
        _react2.default.createElement(
          'section',
          { className: 'bars' },
          _react2.default.createElement(
            'ul',
            { className: 'content' },
            _react2.default.createElement(
              'li',
              { className: 'item' },
              _react2.default.createElement('input', {
                className: 'filter',
                placeholder: 'filter',
                keys: this.state.keys,
                onChange: this.filterKeys.bind(this) })
            ),
            _react2.default.createElement(
              'li',
              { className: 'item' },
              _react2.default.createElement(
                'label',
                { className: 'chebox-label' },
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  className: 'checkbox',
                  checked: this.state.hideConnectUrls,
                  onChange: this.changeHideConnectUrls.bind(this)
                }),
                ' Hide CONNECT URLs'
              )
            ),
            filters.map(function (item) {
              var cls = item === check ? 'item checked' : 'item';
              return _react2.default.createElement(
                'li',
                { key: item, className: cls, onClick: _this3.switchFileType.bind(_this3, item) },
                item
              );
            })
          )
        ),
        _react2.default.createElement(_table.Tables, {
          data: this.getRequestsData(),
          showRequestDetail: this.showRequestDetail.bind(this),
          currIndex: this.state.currIndex
        }),
        _react2.default.createElement(_dialog2.default, {
          showRequestDetail: this.state.showRequestDetail,
          requestDetail: this.state.requestDetail,
          onClose: this.onClose.bind(this)
        })
      );
    }
  }, {
    key: 'showQRCode',
    value: function showQRCode() {
      clearTimeout(this.hideTimer);

      this.setState({
        showQRCode: true
      });
    }
  }, {
    key: 'hideQRCode',
    value: function hideQRCode() {
      var _this4 = this;

      if (window.isHoverQrCode) {
        return;
      }
      this.hideTimer = setTimeout(function () {
        _this4.setState({
          showQRCode: false
        });
      }, 200);
    }
  }, {
    key: 'getRequestsData',
    value: function getRequestsData() {
      var reqs = this.props.requests;
      if (this.state.hideConnectUrls === true) {
        reqs = reqs.filter(function (req) {
          return req.type !== 'connect';
        });
      }

      return reqs.sort(function (a, b) {
        return a.startTime - b.startTime;
      });
    }
  }, {
    key: 'filterKeys',
    value: function filterKeys(e) {
      var val = e.currentTarget.value;
      // this.filterKeys(val);
      this.setState({
        keys: val
      }, this.props.filterKeys(val));
    }
  }, {
    key: 'switchFileType',
    value: function switchFileType(type) {
      var check = this.state.check;

      if (type !== check) {
        this.setState({
          check: type
        }, this.props.filterType(type));
      }
    }
  }, {
    key: 'showRequestDetail',
    value: function showRequestDetail(item) {
      var id = item.id,
          key = item.key;


      this.isClick = true;

      this.setState({
        showRequestDetail: true,
        requestDetail: this.props.requests.filter(function (req) {
          return req.id === id;
        })[0] || {},
        currIndex: id
      });
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.setState({
        currIndex: -1,
        showRequestDetail: false
      });
    }
  }, {
    key: 'changeHideConnectUrls',
    value: function changeHideConnectUrls() {
      this.setState({
        hideConnectUrls: !this.state.hideConnectUrls
      });
    }
  }]);

  return Home;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    requests: state.requests
  };
};

var mapDispatchToProps = {
  onArrive: _action.onArrive,
  clearAll: _action.clearAll,
  filterType: _action.filterType,
  filterKeys: _action.filterKeys
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home);


//////////////////
// WEBPACK FOOTER
// ./src/page/index.js
// module id = 194
// module chunks = 0